import {Pipe, PipeTransform} from '@angular/core';
import * as compareAsc from 'date-fns/compare_asc';
import * as compareDesc from 'date-fns/compare_desc';
import {OrderStatus} from "../../model";

@Pipe({name: 'pools'})
export class PoolsPipe implements PipeTransform {

  transform(value: Order[], sort?: string): any {
    return value ? value
      .filter(order => {
        if (!order.hasSubmittals) return false;
        switch (order.statusId) {
          case OrderStatus.Inquiry:
          case OrderStatus.New:
          case OrderStatus.PendingApproval:
          case OrderStatus.Approved:
            break;
          default:
            return false;
        }
        return true;
      })
      .sort((a, b) => {
        let num = 0;
        switch (sort) {
          case 'updated-desc':
            if (PoolsPipe.needsAction(a)) {
              if (!PoolsPipe.needsAction(b)) return -1;
            } else if (PoolsPipe.needsAction(b)) return 1;
            num = compareDesc(a.latestSubmittal, b.latestSubmittal);
            break;
          case 'updated-asc':
            num = compareAsc(a.latestSubmittal, b.latestSubmittal);
            break;
          case 'created-desc':
            num = compareDesc(a.createDate, b.createDate);
            break;
          case 'created-asc':
            num = compareAsc(a.createDate, b.createDate);
            break;
        }
        if (!num) num = a.position.localeCompare(b.position);
        return num;
      })
      : [];
  }

  private static needsAction(pool: Order): boolean {
    return !pool.reviewed || !!pool.numUnreviewedCandidates;
  }
}
